/* eslint-disable @typescript-eslint/naming-convention */

import SHIPPING_METHODS from '../../../constants/ShippingMethods';
import { IDeliveryOption } from '../../../domain/entities/Transaction/Transaction';
import { IShippingMethod } from '../../../domain/entities/ShippingMethodsCollection/ShippingMethodsCollection';
import { IShipOption, IDeliveryOptionResponse, IConvenienceStoreProviderResponse, IDeliveryOptionConfig } from '../../IApiResponses';
import { DeliveryOptions } from '../../../constants/Constants';
import { CONVENIENCE_STORE, IConvenienceStoreProvider } from '../../../domain/entities/Config';

const shipOptionsMapper = {
  response(shipOptions: IShipOption[]): IShippingMethod[] {
    return shipOptions.map(item => {
      return {
        availableWindow: item.available_window ? {
          startHour: item.available_window.start_hour,
          stopHour: item.available_window.stop_hour,
          timeZone: item.available_window.timezone,
        } : null,
        countryIds: item.country_ids?.map((countryId: string) => Number(countryId)) || [],
        discount: item.discount,
        estimatedDeliveryEndDate: item.estimated_delivery_end_date,
        estimatedDeliveryStartDate: item.estimated_delivery_start_date,
        id: (item.ship_method_id || item.id) as SHIPPING_METHODS,
        leadTimeValue: item.leadtimevalue || item.lead_time_value,
        name: item.name,
        nextAvailableSat: item.next_available_sat,
        price: item.price,
        skuId: item.sku_base_id,
        sortOrder: item.sort_order,
        totalPrice: item.discount ? item.price + item.discount : item.price,
      };
    });
  },
};

const mapConvenienceStoreProvider = (provider: IConvenienceStoreProviderResponse): IConvenienceStoreProvider => {
  const {
    cvsname,
    eshopid,
    ECDCNO,
    ECCVS,
    mobile_cvsname_suffix,
    name,
    post_url,
    post_url_mobile,
    post_url_pc,
    return_url,
    servicetype,
    url,
    VDRNO,
    is_default,
  } = provider;
  return {
    cvsName: cvsname,
    eShopId: String(eshopid),
    ecCdcNo: ECDCNO,
    ecCvs: ECCVS,
    isDefault: !!is_default,
    mobileCvsNameSuffix: mobile_cvsname_suffix,
    name: name as CONVENIENCE_STORE,
    postUrl: post_url,
    postUrlMobile: post_url_mobile,
    postUrlPc: post_url_pc,
    returnUrl: return_url,
    serviceType: String(servicetype),
    url: url,
    vdrNo: String(VDRNO),
  };
};

const getConvenienceStoreProviders = (config: IDeliveryOptionConfig): IConvenienceStoreProvider[] => {
  return config?.convenienceStoreProviders?.reduce((acc: IConvenienceStoreProvider[], provider: IConvenienceStoreProviderResponse) => {
    switch (provider.name) {
      case CONVENIENCE_STORE.FAMILY_MART:
      case CONVENIENCE_STORE.HI_LIFE: {
        if (provider.is_enable == 1) {
          acc.push(mapConvenienceStoreProvider(provider));
        }
        break;
      }
      default: {
        acc.push(mapConvenienceStoreProvider(provider));
        break;
      }
    }
    return acc;
  }, []);
};

const deliveryOptionsMapper = {
  response(deliveryOptions: IDeliveryOptionResponse[]): IDeliveryOption[] {
    return deliveryOptions?.map(deliveryOption => {
      const { default_shipping_method_id, shipping_methods, name, config } = deliveryOption;
      const shipMethods = shipOptionsMapper.response(shipping_methods);
      return {
        config: {
          ...config,
          convenienceStoreProviders: getConvenienceStoreProviders(config),
        },
        defaultMethodId: default_shipping_method_id,
        name: name as DeliveryOptions,
        shipMethods,
      };
    });
  },
};

export default deliveryOptionsMapper;
